import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_146a305a";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_146a305a" };
/** script content **/
require("./picker-popup-base.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Fpicker-popup-base146a305a%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fpicker-popup%2Fpicker-popup-base.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_146a305a"],
    ctorType: "component",
    outputPath: "components/picker-popup-base146a305a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-popup': getComponent(require("../popup/index.mpx?isComponent&outputPath=components%2Findex106ca599%2Findex")), 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
